import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: any;
}

@Component({
  selector: 'ks-custom-dropdown',
  standalone: false,
  templateUrl: './custom-dropdown.component.html',
  styleUrl: './custom-dropdown.component.scss',
})
export class CustomDropdownComponent {
  @Input() label: string = '';
  @Input() options: DropdownOption[] = [];
  @Input() value: any = null;
  @Input() placeholder: string = 'Select';

  @Output() valueChange = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();

  isOpen = false;

  constructor(private elementRef: ElementRef) {}

  get selectedOptionLabel(): string {
    const selected = this.options.find(opt => opt.value === this.value);
    return selected ? selected.label : this.placeholder;
  }

  toggleOpen(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.isOpen = !this.isOpen;
  }

  selectOption(val: any, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.value = val;
    this.valueChange.emit(val);
    this.selectionChange.emit(val);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
